import React from "react";
import styled from "styled-components";

export const StockColumn = styled.div`
    color: black;
    text-transform: none;
    font-size: 11px;
`;

export const StockDetailsContainer = styled.div`
    display: flex;
    flex-direction: column;
    font-weight: normal;
`;

const TruncatableText = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const StockTicker = styled(TruncatableText)`
    font-weight: bold;
`;

export const StockName = styled(TruncatableText)`
    font-size: 10px;
`;